import { Map } from 'immutable'

/** Airport name and location (easy visual ref) */
export const airportNameLoc = ( airport = Map() ) =>
    `${airport.get('name')}, ${airport.get('city')} (${airport.get('iataCode')})` // Silly impl


/** Fail-safe rendering of `airportNameLoc` using iata code
 * and lookup Map.
 */
export const airportNameLocByIata = (iata, airportByIata = Map) =>
    airportByIata.has( iata )
        ? airportNameLoc( airportByIata.get(iata) )
        : iata

/** Produces a version of an airport with a 'label' set. Useful for
 * certain UI display components, etc.
 */
export const setLabel = (airport = Map()) =>
    !airport.get('label')
        ? airport.set('label',
            `${airport.get('name')}, ${airport.get('city')}, ${airport.get('country')} (${airport.get('iataCode')})`)
        : airport

export const setLabelWithQuery = query => (airport = Map()) =>
  !airport.get('label')
      ? airport.set('label',
          `${query} ${airport.get('name')}, ${airport.get('city')}, ${airport.get('country')} (${airport.get('iataCode')})`)
      : airport



// WEBPACK FOOTER //
// ./src/ndc/airport/airportUtils.js